import React, { useState } from 'react'
import StatusBadge from './StatusBadge'

function fmt(ts) {
  if (!ts) return ''
  const d = new Date(ts)
  return d.toLocaleString('th-TH', { dateStyle: 'short', timeStyle: 'short' })
}

export default function CommentThread({
  comments,
  currentRole, // 'staff' | 'student'
  currentId,   // t_id or st_id
  onSubmit,
  disabled = false,
}) {
  const [body, setBody] = useState('')
  const [busy, setBusy] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    const text = body.trim()
    if (!text) return
    setBusy(true)
    try {
      await onSubmit(text)
      setBody('')
    } finally {
      setBusy(false)
    }
  }

  return (
    <div>
      <div className="d-flex flex-column gap-2 mb-3">
        {comments.length === 0 && (
          <div className="text-muted text-center small py-3">ยังไม่มีความคิดเห็น</div>
        )}
        {comments.map(c => {
          const isMine =
            (c.author_role === 'staff'   && currentRole === 'staff'   && c.author_t_id === currentId) ||
            (c.author_role === 'student' && currentRole === 'student' && c.author_st_id === currentId)
          const isSystem = c.author_role === 'system'

          if (isSystem) {
            return (
              <div key={c.ic_id} className="text-center small text-muted py-1">
                <i className="ri-information-line me-1" />
                {c.ic_status_to
                  ? <>เปลี่ยนสถานะเป็น <StatusBadge status={c.ic_status_to} /></>
                  : c.ic_body}
                <span className="ms-2">{fmt(c.ic_created_at)}</span>
              </div>
            )
          }
          return (
            <div key={c.ic_id} className={`d-flex ${isMine ? 'justify-content-end' : 'justify-content-start'}`}>
              <div
                className={`p-2 px-3 rounded-3 ${isMine ? 'bg-primary text-white' : 'bg-light'}`}
                style={{ maxWidth: '85%' }}
              >
                <div className="small fw-semibold mb-1" style={{ opacity: isMine ? 0.85 : 0.7 }}>
                  {c.author_name || (c.author_role === 'student' ? 'นักเรียน' : 'บุคลากร')}
                </div>
                <div style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{c.ic_body}</div>
                <div className="small text-end mt-1" style={{ opacity: 0.7 }}>
                  {fmt(c.ic_created_at)}
                </div>
              </div>
            </div>
          )
        })}
      </div>

      {!disabled && (
        <form onSubmit={handleSubmit} className="d-flex gap-2">
          <textarea
            className="form-control"
            placeholder="พิมพ์ความคิดเห็น..."
            rows={2}
            value={body}
            onChange={e => setBody(e.target.value)}
          />
          <button type="submit" className="btn btn-primary" disabled={busy || !body.trim()}>
            {busy ? <span className="spinner-border spinner-border-sm" /> : <i className="ri-send-plane-fill" />}
          </button>
        </form>
      )}
    </div>
  )
}
